import { Link } from "react-router-dom";

const Info = () => (
  <section id="info" className="gg-bg-solid-blue">
    <div className="container-fluid pt-4 text-white">
      <div className="row justify-content-center align-items-center text-center">
        <div className="col-md-10">
          <nav>
            <ul className="px-0">
              <li className="list-inline-item mx-3">
                <Link to="/info/contact" target="_blank" className="text-decoration-none text-white">Contact Us</Link>
              </li>
              <li className="list-inline-item mx-3">
                <Link to="/info/terms-and-conditions" target="_blank" className="text-decoration-none text-white">Terms and Conditions</Link>
              </li>
              <li className="list-inline-item mx-3">
                <Link to="/info/return-policy" target="_blank" className="text-decoration-none text-white">Return Policy</Link>
              </li>
              <li className="list-inline-item mx-3">
                <Link to="/info/privacy" target="_blank" className="text-decoration-none text-white">Privacy</Link>
              </li>
            </ul>
          </nav>
          <hr />
        </div>
      </div>
    </div>
  </section >
);

export default Info;